import { render, staticRenderFns } from "./saldo_form.vue?vue&type=template&id=42859090&"
import script from "./saldo_form.vue?vue&type=script&lang=js&"
export * from "./saldo_form.vue?vue&type=script&lang=js&"
import style0 from "./saldo_form.vue?vue&type=style&index=0&id=42859090&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports